export const receiptConstants = {

    ADD_RECEIPT_REQUEST: 'ADD_RECEIPT_REQUEST',
    ADD_RECEIPT_SUCCESS: 'ADD_RECEIPT_SUCCESS',
    ADD_RECEIPT_FAILURE: 'ADD_RECEIPT_FAILURE',

    GET_RECEIPTS_REQUEST: 'GET_RECEIPTS_REQUEST',
    GET_RECEIPTS_SUCCESS: 'GET_RECEIPTS_SUCCESS',
    GET_RECEIPTS_FAILURE: 'GET_RECEIPTS_FAILURE',

    EDIT_RECEIPT_STATUS_REQUEST: 'EDIT_RECEIPT_STATUS_REQUEST',
    EDIT_RECEIPT_STATUS_SUCCESS: 'EDIT_RECEIPT_STATUS_SUCCESS',
    EDIT_RECEIPT_STATUS_FAILURE: 'EDIT_RECEIPT_STATUS_FAILURE',

    EDIT_RECEIPT_REQUEST: 'EDIT_RECEIPT_REQUEST',
    EDIT_RECEIPT_SUCCESS: 'EDIT_RECEIPT_SUCCESS',
    EDIT_RECEIPT_FAILURE: 'EDIT_RECEIPT_FAILURE',

    CONFIRM_FINANCIAL_RECEIPT_REQUEST: 'CONFIRM_FINANCIAL_RECEIPT_REQUEST',
    CONFIRM_FINANCIAL_RECEIPT_SUCCESS: 'CONFIRM_FINANCIAL_RECEIPT_SUCCESS',
    CONFIRM_FINANCIAL_RECEIPT_FAILURE: 'CONFIRM_FINANCIAL_RECEIPT_FAILURE',

    EDIT_RECEIPT_NOTE_STATUS_REQUEST: 'EDIT_RECEIPT_NOTE_STATUS_REQUEST',
    EDIT_RECEIPT_NOTE_STATUS_SUCCESS: 'EDIT_RECEIPT_NOTE_STATUS_SUCCESS',
    EDIT_RECEIPT_NOTE_STATUS_FAILURE: 'EDIT_RECEIPT_NOTE_STATUS_FAILURE',
}